import React from 'react'
import { CChartBar } from '@coreui/react-chartjs'

// Revenue-per-day bars. data: [{ name: 'YYYY-MM-DD', count, price }]
export default function PreOrdersChart({ data = [], style }) {
    return (
        <div style={style || { height: '300px' }}>
            <CChartBar
                data={{
                    labels: data.map(d => d.name),
                    datasets: [{
                        label: 'Revenue',
                        data: data.map(d => d.price ?? 0),
                        backgroundColor: 'rgba(79, 172, 254, 0.7)',
                        borderRadius: 6,
                    }],
                }}
                options={{
                    maintainAspectRatio: false,
                    plugins: { legend: { display: false } },
                    scales: { y: { beginAtZero: true } },
                }}
            />
        </div>
    )
}
